import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.vhdl = bracketIndenting({
	line: "--",
})
